import { PluggableStorage } from './PluggableStorage';

const STORAGE_KEY = 'session';
const LEGACY_SS_KEY = 'weave_session_id';

interface WeaveSession {
  id: string;
  startTime: number;
}

let storage: PluggableStorage | null = null;

function getStorage(): PluggableStorage {
  if (!storage) {
    storage = PluggableStorage.create('weave');
  }
  return storage;
}

/**
 * Migrates the session ID from the old sessionStorage key into
 * the new PluggableStorage JSON entry.
 *
 * TODO: remove after a few weeks in production
 */
function migrateFromSessionStorage(): WeaveSession | null {
  try {
    const ssId = sessionStorage.getItem(LEGACY_SS_KEY);
    if (ssId != null) {
      const session: WeaveSession = { id: ssId, startTime: Date.now() };
      getStorage().setItem(STORAGE_KEY, session);
      sessionStorage.removeItem(LEGACY_SS_KEY);
      return session;
    }
  } catch (e) {
    console.error('weave session error', e);
  }
  return null;
}

function getSession(): WeaveSession | null {
  return getStorage().getItem<WeaveSession>(STORAGE_KEY) ?? migrateFromSessionStorage();
}

export function startWeaveSession() {
  try {
    if (getSession() != null) return;
    getStorage().setItem(STORAGE_KEY, { id: crypto.randomUUID(), startTime: Date.now() });
  } catch (e) {
    console.error('weave session error', e);
  }
}

export function getWeaveSessionId(): string | null {
  try {
    return getSession()?.id ?? null;
  } catch (e) {
    console.error('weave session error', e);
    return null;
  }
}

export function getWeaveSessionLength(): number | null {
  try {
    const session = getSession();
    if (!session) return null;
    return Date.now() - session.startTime;
  } catch (e) {
    console.error('weave session error', e);
    return null;
  }
}

export function deleteWeaveSessionId(): void {
  try {
    getStorage().removeItem(STORAGE_KEY);
    sessionStorage.removeItem(LEGACY_SS_KEY);
  } catch (e) {
    console.error('weave session error', e);
  }
}
